<template>
  <div class="resource-view">
    <div class="resource-top">
      <div class="resource-nav">
        <!-- <small class="nav-icon">
          <i class="el-icon-back"></i>
        </small> -->
        <span>企业选址</span>
        <small class="nav-"> / </small>
        <span class="nav-link">资源详情</span>
      </div>
    </div>
    <div class="resource-main">
      <el-scrollbar class="page-component__scroll" style="height: 100%">
        <section class="section">
          <div class="section-top">
            <div class="top-left">
              <el-carousel
                height="280px"
                v-if="listData.picture && listData.picture[0]"
              >
                <el-carousel-item
                  v-for="(item, index) in listData.picture"
                  :key="index"
                >
                  <img :src="item.url" alt="" srcset="" class="imgA" />
                </el-carousel-item>
              </el-carousel>
              <el-empty :image-size="100" v-else></el-empty>
            </div>
            <div class="top-right">
              <h3 class="entName">{{ listData.name || "--" }}</h3>
              <div class="top-info">
                <div class="list-box">
                  <p>
                    <label>园区地址:</label
                    ><span>{{ listData.address || "--" }}</span>
                  </p>
                  <p>
                    <label>建成年份:</label
                    ><span>{{ listData.year || "--" }}</span>
                  </p>
                  <p>
                    <label>所属街道:</label
                    ><span>{{ listData.street || "--" }}</span>
                  </p>
                  <p>
                    <label>工业地价(万/亩):</label
                    ><span>{{ listData.industrialPrice || "--" }}</span>
                  </p>
                </div>
                <div class="list-box">
                  <p>
                    <label>园区总面积(m²):</label
                    ><span>{{ listData.areaTotal || "--" }}</span>
                  </p>
                  <p>
                    <label>可出租面积(m²):</label
                    ><span>{{ listData.areaFree || "--" }}</span>
                  </p>
                  <p>
                    <label>办公租房(元/m²/天):</label
                    ><span>{{ listData.officeRent || "--" }}</span>
                  </p>
                  <p>
                    <label>主导产业:</label
                    ><span>{{ listData.industry || "--" }}</span>
                  </p>
                </div>
                <div class="list-box ">
                  <div class="box-phone">
                    <p>园区联系电话</p>
                    <p class="phone">{{ listData.telephone || "--" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-bottom">
            <!-- <div class="type-swith">
              <small
                :class="[type == 'A' ? 'active' : '']"
                @click="typeChange('A')"
              >
                园区详情
              </small>
              <small
                :class="[type == 'B' ? 'active' : '']"
                @click="typeChange('B')"
              >
                土地信息
              </small>
              <small
                :class="[type == 'C' ? 'active' : '']"
                @click="typeChange('C')"
              >
                空间位置
              </small>
            </div> -->
            <div class="info-type-box">
              <h3>园区详情</h3>
              <div class="list-box park-info">
                <div>
                  <label>园区资料:</label>
                  <div v-if="listData.resource">
                    <p
                      v-for="item in listData.resource"
                      @click="jump(item)"
                      :key="item.uid"
                      class="file-item"
                    >
                      {{ item.name }}
                    </p>
                  </div>
                  <span v-else>--</span>
                </div>
                <p>
                  <label>企业数据:</label
                  ><span>{{ listData.industrialPrice || "--" }}</span>
                </p>
              </div>
              <div class="list-box">
                <p>
                  <label>园区优企:</label
                  ><span>{{ listData.goodEnt || "--" }}</span>
                </p>
              </div>
              <div class="list-box">
                <p>
                  <label>园区简介:</label
                  ><span>{{ listData.introduction || "--" }}</span>
                </p>
              </div>
            </div>
            <div class="info-type-box">
              <h3>土地信息</h3>
              <div class="list-box park-info">
                <p>
                  <label>地块编码:</label
                  ><span>{{ listData.landCode || "--" }}</span>
                </p>
                <p>
                  <label>用地性质:</label
                  ><span>{{ listData.landNature || "--" }}</span>
                </p>
                <p>
                  <label>土地面积(㎡):</label
                  ><span>{{ listData.landArea || "--" }}</span>
                </p>
              </div>
              <div class="list-box park-info">
                <p>
                  <label>容积率:</label
                  ><span>{{ listData.plotRatio || "--" }}</span>
                </p>
                <p>
                  <label>总价(万元):</label
                  ><span>{{ listData.totalPrice || "--" }}</span>
                </p>
              </div>
            </div>
            <div class="info-type-box">
              <h3>空间位置</h3>
              <div class="amap" id="amap"></div>
            </div>
          </div>
        </section>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
// import AMapLoader from "@amap/amap-jsapi-loader";
import { getParkDetailById } from "@/api/resource";
export default {
  data() {
    return {
      listData: {},
      type: "A",
      AMap: null
    };
  },
  created() {
    let { sid } = this.$route.query;
    if (sid) {
      this.getInfo(sid);
    }
  },
  mounted() {},
  methods: {
    jump(item) {
      window.open(item.url);
    },
    async getInfo(id) {
      let { data } = await getParkDetailById({ id: id });
      if (data.picture) {
        data.picture = JSON.parse(data.picture);
      }
      if (data.resource) {
        data.resource = JSON.parse(data.resource);
      }
      this.listData = data;
      this.getAMapInit();
    },
    getAMapInit() {
      let $this = this;
      // eslint-disable-next-line no-undef
      AMapLoader.load({
        key: "950c0df7de3613bb3d721e3bf5ab11e7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Adaptor", "AMap.MarkerCluster"],
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: "2.0" // Loca 版本，缺省 1.3.2
        }
      })
        .then(AMap => {
          $this.AMap = new AMap.Map("amap", {
            resizeEnable: true,
            keyboardEnable: false,
            zoom: 7.9,
            mapStyle: "amap://styles/9d4c949a703c9ce96127d9828f918b8f"
          });
          $this.AMap.on("complete", function() {
            let list = $this.listData.jwd.split(",");
            var marker = new AMap.Marker({
              position: list, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: $this.listData.name
            });

            // 将创建的点标记添加到已有的地图实例：
            $this.AMap.add(marker);
            $this.AMap.setFitView(marker);
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  destroyed() {
    this.AMap.destroy();
  }
};
</script>

<style lang="less" scoped>
.resource-view {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.resource-top {
  height: 40px;
  background: #fff;
  border: 1px solid #dae3fa;
}
.resource-main {
  height: 0;
  flex: 1;
  position: relative;
}
.resource-nav {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  line-height: 40px;
  & .nav- {
    padding: 0 4px;
  }
  & .nav-link {
    color: rgba(79, 121, 253, 1);
  }
  & .nav-icon {
    margin-right: 10px;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: rgba(79, 121, 253, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    & i {
      color: #fff;
    }
  }
}
.section {
  padding: 20px;
}
.section-bottom {
  border-radius: 6px;
  background: #fff;
  margin-top: 20px;
  padding: 20px;
}
.section-top {
  padding: 20px;
  display: flex;
  border-radius: 6px;
  background: #fff;
  & .top-left {
    width: 500px;
    height: 280px;
    background: rgba(230, 230, 230, 0.5);
    margin-right: 30px;
  }
  & .top-right {
    width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    & .entName {
      color: rgba(54, 54, 54, 1);
      font-size: 22px;
      padding-bottom: 15px;
    }
    & .top-info {
      height: 0;
      flex: 1;
      display: flex;
      & > div:nth-of-type(1) {
        width: 0;
        flex: 1;
      }
      & > div:nth-of-type(2) {
        width: 0;
        flex: 1;
      }
      & > div:nth-of-type(3) {
        padding-left: 50px;
      }
    }
  }
}
.list-box {
  & > p {
    padding: 12px 0;
    color: rgba(43, 43, 43, 1);
    font-size: 14px;
    display: flex;
    word-wrap: break-word;
    word-break: normal;
    & > span {
      width: 0;
      flex: 1;
    }
    & label {
      margin-right: 10px;
    }
  }
  & > div {
    display: flex;
    padding: 12px 0;
    color: rgba(43, 43, 43, 1);
    font-size: 14px;
    & label {
      margin-right: 10px;
    }
  }
}
.box-phone {
  position: relative;
  display: block !important;
  padding: 0 !important;
  &::before {
    content: "";
    position: absolute;
    left: -30px;
    top: 0;
    border-left: 1px dashed rgba(255, 136, 0, 1);
    height: 60px;
  }
  & p {
    font-size: 16px;
  }
  & .phone {
    color: rgba(255, 136, 0, 1);
    font-size: 22px;
    padding-top: 16px;
  }
}
.imgA {
  display: block;
  width: 100%;
  height: 100%;
}
.type-swith {
  display: flex;
  padding: 0 15px;
}
.type-swith small {
  color: #434343;
  font-size: 16px;
  padding: 8px 0px;
  width: 89px;
  text-align: center;
  cursor: pointer;
  background: #f7f8fa;
  border: 1px solid #a0a0a0;
  transition: 0.3s;
  &:nth-child(1) {
    border-right: 0 none;
  }
  &:nth-child(2) {
    border-right: 0 none;
  }
}
.type-swith small.active {
  color: #2d77fc;
  border-bottom: 0 none;
  background: #fff;
}
.park-info {
  display: flex;
  flex-wrap: nowrap;
  & > p {
    margin-right: 15%;
    display: flex;
    white-space: nowrap;
    & > span {
      width: 0;
      flex: 1;
    }
  }
  & > div {
    margin-right: 20%;
  }
}
.file-item {
  cursor: pointer;
  &:hover {
    color: #2d77fc;
  }
}
.info-type-box {
  & > h3 {
    font-size: 16px;
    color: rgba(79, 121, 253, 1);
    padding: 15px 0;
  }
}
.amap {
  height: 320px;
}
</style>
